module.exports = __webpack_public_path__ + "img/doc-md@2x.7897eeb1.jpg";